
import React, { createContext, useReducer, useEffect, useContext, useState } from "react";
import { withApollo } from '@apollo/react-hoc';
import { message } from 'antd'
import { withRouter, useLocation } from 'react-router-dom';
import { ListQuestionTemplatesQuery, listFormTemplatesQuery, updateFormTemplateMut, createFormTemplateMut, createQuestionTemplateMut, 
  updateQuestionTemplateMut, getFormTemplateBySlugValueQuery, createFormTemplateActivityMut, getFormTemplateByUIdQuery } from '../../../../common/graphqlFunctions';
import { QuestionStoreW } from './question-context-reducer'
import slugify from 'slugify';
import{ returnFormattedDemodata, getDataFromDbForm, compareForUnsavedChanges } from '../templateMaster/functions'
import { AuthContext } from '../../../../../context/authContext';
import { FormAssignStoreW } from './assignForm-reduce'
import Template from '../templateMaster/objectTemplates/templateObj'
import { cloneFormTemplate, deleteFormTemplate } from '../../../../../graphql/mutations';

/**
 * @typedef properties
 * @property {string} pageSize 
 * @property {boolean} repeatFooter
 * @property {boolean} repeatHeader
 * @property {boolean} repeatTitle
 * @property {boolean} showFormTitle
 * @property {string} bgColor
 * @property {string} bgImg
 * @property {Array} variables
 */

/**
 * @typedef section
 * @property {boolean} isEditing 
 * @property {Array} questions
 * @property {string} title
 */

/**
 * @typedef column
 * @property {boolean} addSection 
 * @property {section[]} sections
 * @property {string} title
 */

/**
 * @typedef row
 * @property {boolean} addColumns 
 * @property {number} index
 * @property {column[]} columns
 * @property {string} title
 */

/**
 * @typedef demoData
 * @property {boolean} active - Flag to see if template is active
 * @property {String} displayName 
 * @property {String} slugValue 
 * @property {String} title 
 * @property {Array<row>} rows 
 * @property {properties} properties 
 */

 /**
  * @typedef initialState
  * @property {Array} questions
  * @property {Array} templates
  * @property {Array} subtemplates
  * @property {undefined|null|String} nexttoken
  * @property {undefined|null|String} nexttokenTemplate
  * @property {undefined|null|String} nexttokenSubtemplates
  * @property {Boolean} loading
  * @property {Boolean} quesLoading
  * @property {demoData} demoData
  * @property {*} basicObj
  * @property {Arrray<string>} keywords
  * @property {*} origObj
  * @property {Boolean} unsavedChanges
  * @property {Boolean} templateCreateLoading  
  * @property {Boolean} templateListLoading
  * @property {Boolean} subtemplateListLoading
  */


export const ADD_QUESTIONS = 'ADD_QUESTIONS'
export const INIT_QUESTIONS = 'INIT_QUESTIONS'
export const SET_LOADING = 'SET_LOADING'
export const SET_NEXT_TOKEN = 'SET_NEXT_TOKEN'
export const SET_DEMO_DATA = 'SET_DEMO_DATA'
export const SET_KEYWORDS = 'SET_KEYWORDS'
export const INIT_TEMPLATES = 'INIT_TEMPLATES'
export const INIT_SUBTEMPLATES = 'INIT_SUBTEMPLATES'
export const ADD_TEMPLATES = 'ADD_TEMPLATES'
export const ADD_SUBTEMPLATE = 'ADD_SUBTEMPLATE'
export const ADD_ORIG_OBJ = 'ADD_ORIG_OBJ'
export const UPDATE_UNSAVED_FLAG = 'UPDATE_UNSAVED_FLAG'
export const DELETE_QUES = 'DELETE_QUES'
export const QUES_LOADING = 'QUES_LOADING'
export const TEMP_CREATE_LOADING = 'TEMP_CREATE_LOADING'
export const CLONE_TEMPLATE = 'CLONE_TEMPLATE'
export const SET_NEXT_TOKEN_TEMPLATE = 'SET_NEXT_TOKEN_TEMPLATE';
export const SET_NEXT_TOKEN_SUBTEMPLATES = 'SET_NEXT_TOKEN_SUBTEMPLATES'
export const TEMP_LIST_LOADING = 'TEMP_LIST_LOADING';
export const SUBTEMP_LIST_LOADING = 'SUBTEMP_LIST_LOADING';





const cloneFormTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: cloneFormTemplate,
          variables: variables
      }).then((data) => {
          res(data)
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}

/**
 * @type {initialState} 
 */
const initialState = {
  questions:[],
  templates:[],
  subtemplates:[],
  nexttoken:undefined,
  nexttokenTemplate:undefined,
  nexttokenSubtemplates:undefined,
  loading: false,
  quesLoading: false,
  demoData: null,
  basicObj: new Template(),
  keywords: [],
  origObj:null,
  unsavedChanges:false,
  templateCreateLoading:false,
  templateListLoading:false,
  subtemplateListLoading:false
};


const addQuestionsToStore=(state,question)=>{
  let arr = [...state.questions];
  if(question){
    let index = arr.filter((a)=>a && a!= null).findIndex((item, i)=>item.slugValue == question.slugValue);
    if(index == -1){
      arr.splice(0,0,question);
    }else{
      arr.splice(index,1,question)
    }
  }
  let modifiedState = {...state, questions: arr}
  return modifiedState
}



const addTemplatesToStore=(state,template)=>{
  let arr = [...state.templates];
  if(template){
    let index = arr.filter((a)=>a && a!= null).findIndex((item, i)=>item.slugValue == template.slugValue);
   
    if(index == -1){
      arr.splice(0,0,template);
    }else{
      arr.splice(index,1,template)
    }
  }
  let modifiedState = {...state, templates: arr}
  return modifiedState
}



const addsubTemplatesToStore=(state,template)=>{
  let arr = [...state.subtemplates];
  if(template){
    let index = arr.filter((a)=>a && a!= null).findIndex((item, i)=>item.slugValue == template.slugValue);
   
    if(index == -1){
      arr.splice(0,0,template);
    }else{
      arr.splice(index,1,template)
    }
  }
  let modifiedState = {...state, subtemplates: arr}
  return modifiedState
}


const cloneTemplatesToStore=(state,payload)=>{
  let arr = [...state.templates];
  if(payload){
    let index = arr.filter((a)=>a && a!= null).findIndex((item, i)=>item.slugValue == payload.slugValue);
    if(index > -1){
      arr.splice(index,1)
    }
    arr.splice(0,0,payload.obj)
  }
  let modifiedState = {...state, templates: arr}
  return modifiedState
}


const deleteQuestion=(state,question)=>{
  let arr = [...state.questions];
  if(question){
    let index = arr.filter((a)=>a && a!= null).findIndex((item, i)=>item.slugValue == question.slugValue);
    if(index == -1){
    }else{
      arr.splice(index,1)
    }
  }
  let modifiedState = {...state, questions: arr}
  return modifiedState
}



const FormReducer = (state, action)=>{
    switch (action.type) {
        case INIT_QUESTIONS:
          return questionsPagination(state,action.payload)
        case ADD_QUESTIONS:
          return addQuestionsToStore(state,action.payload);
        case DELETE_QUES:
          return deleteQuestion(state,action.payload);
        case SET_LOADING:
          return {...state, loading : action.payload }
        case SET_NEXT_TOKEN:
          return {...state, nexttoken : action.payload }
        case SET_NEXT_TOKEN_TEMPLATE:
          return {...state, nexttokenTemplate : action.payload } //templates
        case SET_NEXT_TOKEN_SUBTEMPLATES:
          return {...state, nexttokenSubtemplates : action.payload } //Sub templates
        case SET_DEMO_DATA:
          return {...state, demoData : action.payload }
        case INIT_TEMPLATES:
          return templatesPagination(state,action.payload)
        case INIT_SUBTEMPLATES:
          return subtemplatesPagination(state,action.payload)
        case ADD_TEMPLATES:
          return addTemplatesToStore(state,action.payload);
        case ADD_SUBTEMPLATE:
          return addsubTemplatesToStore(state,action.payload)
        case CLONE_TEMPLATE:
          return cloneTemplatesToStore(state, action.payload)
        case ADD_ORIG_OBJ:
          return {...state, origObj: action.payload };
        case UPDATE_UNSAVED_FLAG:
          return {...state, unsavedChanges: action.payload};
        case QUES_LOADING:
          return {...state, quesLoading: action.payload };
        case TEMP_CREATE_LOADING:
          return {...state, templateCreateLoading: action.payload }
        case TEMP_LIST_LOADING:
          return {...state, templateListLoading: action.payload }
        default:
          return state
      }
}



const questionsPagination=(state, payload)=>{
  let finalState = {...state}
  if(state.nexttoken != null){
    finalState = {...state, questions : [...state.questions,...payload]}
  }
  if(state.nexttoken == undefined){
    finalState = {...state, questions : payload}
  }
  return finalState
}


const templatesPagination=(state, payload)=>{
  let finalState = {...state}
  if(state.nexttokenTemplate != null){
    finalState = {...state, templates : [...state.templates,...payload]}
  }
  if(state.nexttokenTemplate == undefined){
    finalState = {...state, templates : payload}
  }
  return finalState
}

const subtemplatesPagination=(state, payload)=>{
  let finalState = {...state}
  if(state.nexttokenSubtemplates != null){
    finalState = {...state, subtemplates : [...state.subtemplates,...payload]}
  }
  if(state.nexttokenSubtemplates == undefined){
    finalState = {...state, subtemplates : payload}
  }
  return finalState
}


const FormStore = (props) => {

  const authContextComp = useContext(AuthContext);


  const [state, dispatch] = useReducer(FormReducer, initialState);
  const [nexttoken, setnexttoken] = useState(undefined);
  const [nexttokenTemplate, setnexttokenTemplate] = useState(undefined);
  const [nexttokensubTemplate, setnexttokensubTemplate] = useState(undefined);
  // const [designerType, setdesignerType] = useState('template');

  let demoData = state.demoData;
  let origObj = state.origObj;
  let basicObj = state.basicObj;

//================== determine subscriber (either global or registered subscriber)
  let subScriber = 'global';
  if(authContextComp.data && authContextComp.data != null){
    subScriber = authContextComp.data.subscriberId
  }

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }


  let query = useQuery();
  let designerType = 'template';

  for (let entry of query.entries()) {
    if (entry[0] == 'type') {
      designerType = entry[1]
    }
  }
 
  //=================== get global question set and forms set
  useEffect(() => {
    const fetchDataAsync = async () => {
      // getQuestionsList()
      getTemplateData('template')
      getTemplateData('subtemplate')

    }
    if(authContextComp.loading == false){
      fetchDataAsync()
    }
  },[authContextComp.loading]);



//======================= question list pagination
useEffect(() => {
  if(nexttoken != null){
    const fetchDataAsync = async () => {
      getQuestionsList()
    }
    if(authContextComp.loading == false){
    fetchDataAsync()
    }
  }
},[nexttoken]);


useEffect(() => {
  if(props.history.location.pathname == '/createQuestion'){
    const fetchDataAsync = async () => {
      getQuestionsList()
    }
    if(authContextComp.loading == false){
    fetchDataAsync()
    }
  }

},[authContextComp.loading]);



useEffect(() => {
  if(props.history.location.pathname == '/createQuestion'){
    const fetchDataAsync = async () => {
      getQuestionsList()
    }
    if(authContextComp.loading == false){
    fetchDataAsync()
    }
  }
},[props.history.location.pathname]);



//======================= template list pagination
useEffect(() => {
  if(nexttokenTemplate != null){
    const fetchDataAsync = async () => {
      getTemplateData('template')
    }
    if(authContextComp.loading == false){
    fetchDataAsync()
    }
  }
},[nexttokenTemplate]);


//======================= sub template list pagination
useEffect(() => {
  if(nexttokensubTemplate != null){
    const fetchDataAsync = async () => {
      getTemplateData('subtemplate')
    }
    if(authContextComp.loading == false){
    fetchDataAsync()
    }
  }
},[nexttokensubTemplate]);




//================ get original form obj - (manage queries)
  useEffect(() => {
    const fetchAsyncFunction=async()=>{
      if(state.demoData != null && state.demoData.title){
        let slugValue = demoData.slugValue;
       let res = await getFormTemplateBySlugValueFun(slugValue)
      //  if(res.data.getFormTemplateBySlugValue != null){
         updateOrigObj(res.data.getFormTemplateBySlugValue)
      //  }
    }
  }
  if(state.demoData && state.demoData.slugValue){
    fetchAsyncFunction()
  }
 },[JSON.stringify(state.demoData)]);



let location = useLocation().pathname
 useEffect(() => {
  const fetchAsyncFunction=async()=>{
    if(state.demoData != null && state.demoData.title){
      let slugValue =demoData.slugValue;
     let res = await getFormTemplateBySlugValueFun(slugValue)
    //  if(res.data.getFormTemplateBySlugValue != null){
       updateOrigObj(res.data.getFormTemplateBySlugValue)
    //  }
  }
}
if(state.demoData && state.demoData.slugValue){
  fetchAsyncFunction()
}
 }, [location])

 //================== original form query with slugname
 const getFormTemplateBySlugValueFun=async(slugValue)=>{
  let variables = {
    slugValue: slugValue,
    typeValue:`${subScriber}::${designerType}`
  }
  let parent = null
  for (let entry of query.entries()) {
    if (entry[0] == 'parent') {
      parent = entry[1]

    }
  }
  if(parent != null){
    variables.typeValue = `${subScriber}::${parent}::${designerType}`
  }

   return await getFormTemplateBySlugValueQuery(props,variables)
 }


 //=================== unsaved changes - (redo)
  useEffect(() => {
    if(state.origObj != null && state.demoData != null){
      let obj = compareForUnsavedChanges(state)
   
      if(obj.origObjStr != obj.demoObj){
        
        dispatch({
          type: UPDATE_UNSAVED_FLAG,
          payload: true
        })
      }else{
        dispatch({
          type: UPDATE_UNSAVED_FLAG,
          payload: false
        })
      }
    }
},[JSON.stringify(state.demoData)+JSON.stringify(state.origObj)]);


  const setloading=(flag)=>{
    dispatch({
      type:SET_LOADING,
      payload: flag
    })
  }

  const setTempListloading=(flag)=>{
    dispatch({
      type:TEMP_LIST_LOADING,
      payload: flag
    })
  }


  const setQuesLoading=(flag)=>{
    dispatch({
      type:QUES_LOADING,
      payload: flag
    })
  }

  const setTempCreateLoading=(flag)=>{
    dispatch({
      type:TEMP_CREATE_LOADING,
      payload: flag
    })
  }

  const updateOrigObj=(data)=>{
    dispatch({
      type: ADD_ORIG_OBJ,
      payload: data
    })
  }


  const getTemplateData=(type)=>{
    setTempListloading(true)
    let variables = {
      typeValue: `${subScriber}::${type ? type : 'template'}`,
      limit:1000,
      nextToken: nexttokenTemplate
    }

    listFormTemplatesQuery(props, variables)
    .then((res)=>{
      setTempListloading(false)
      if(res.data.listFormTemplates && res.data.listFormTemplates.items.length > 0){
          let arr = res.data.listFormTemplates.items
          // .sort((a,b)=>(b.updatedAt ? b.updatedAt : b.createdAt) - ( a.updatedAt ? a.updatedAt : a.createdAt))
          .map((item, i)=>{
              if(item&& item!=null){
                  item.key = item.slugValue;
                  return item
              }
            })
            if(type == 'subtemplate'){
              dispatch({
                type:INIT_SUBTEMPLATES,
                payload : arr
              })
      
              dispatch({
                type: SET_NEXT_TOKEN_SUBTEMPLATES,
                payload : res.data.listFormTemplates.nextToken
              })
              setnexttokensubTemplate(res.data.listFormTemplates.nextToken)
            }else{
              dispatch({
                type:INIT_TEMPLATES,
                payload : arr
              })
      
              dispatch({
                type: SET_NEXT_TOKEN_TEMPLATE,
                payload : res.data.listFormTemplates.nextToken
              })
              setnexttokenTemplate(res.data.listFormTemplates.nextToken)
            }
     
      }
    }).catch((err)=>{
      console.log(err)
      setTempListloading(false)
    })
  }
    
    
    const deleteFormTemplateMut = async (props, variables) => {
  return await new Promise((res, rej) => {
      props.client.mutate({
          mutation: deleteFormTemplate,
          variables: variables
      }).then((data) => {
          res(data);
           if (data.data.deleteFormTemplate != null) {
          message.success('Form deleted Successfully')
        }
        getTemplateData('template');
      }).catch((err) => {
          // console.log(err)
          rej(err)
      })
  })
}

  const getQuestionsList=()=>{
    setQuesLoading(true)
    let variables = {
      typeValue: `${subScriber}::question`,
      limit:1000,
      nextToken: nexttoken
    }
    ListQuestionTemplatesQuery(props, variables)
      .then((res) => {
        // console.log(res)
        if (res.data && res.data.listQuestionTemplates && res.data.listQuestionTemplates != null) {
          dispatch({
            type:INIT_QUESTIONS,
            payload : res.data.listQuestionTemplates.items
          })
          dispatch({
            type: SET_NEXT_TOKEN,
            payload : res.data.listQuestionTemplates.nextToken
          })
          setnexttoken(res.data.listQuestionTemplates.nextToken)
        }
        setQuesLoading(false)
      }).catch((err) => {
        console.log(err)
        setQuesLoading(false)
      })
  }


  const updateQuestionsData=(data)=>{
    dispatch({
      type: ADD_QUESTIONS,
      payload: data
    })
  }

  const deleteQuesiton=(data)=>{
    dispatch({
      type: DELETE_QUES,
      payload: data
    })
  }


  const setdemoData=(data)=>{
    dispatch({
      type: SET_DEMO_DATA,
      payload: data
    })
  }


  const onRowTitleChange = (val, rowIndex) => {
    basicObj.updateRowTitle(val, rowIndex)
    setdemoData(basicObj.returnTemplate())
  }


  const onChange = (val) => {
    basicObj.updateTitle(val)
    setdemoData(basicObj.returnTemplate())
  }


  const onColTitleChange = (val, colIndex, rowIndex) => {
    basicObj.updateColumnTitle(val, colIndex, rowIndex)
    setdemoData(basicObj.returnTemplate())
  }


  const onSecTitleChange = (val, secIndex, colIndex, rowIndex) => {
    basicObj.updateSectionTitle(val, secIndex, colIndex, rowIndex)
    setdemoData(basicObj.returnTemplate())
  }


//================================= form disable - (dont have any dependency)
  const handleTemplateDisable = (checked, record) => {
    setloading(true)
    let variables={
        typeValue: record.typeValue,
        slugValue: record.slugValue,
        templateName: record.templateName,
        questionRefs: record.questionRefs ? record.questionRefs : ['abc'],
        active:checked
    }
    updateFormTemplateMut(props,variables)
    .then(({data})=>{
      message.success('Updated Successfully');

      if(designerType == 'subtemplate'){
        dispatch({
          type: ADD_SUBTEMPLATE,
          payload: data.updateFormTemplate
        })
      }else{
        dispatch({
          type: ADD_TEMPLATES,
          payload: data.updateFormTemplate
        })
      }

      dispatch({
        type: SET_LOADING,
        payload: false
      })
    }).catch((err)=>{
      console.log(err)
      dispatch({
        type: SET_LOADING,
        payload: false
      })
      message.error('There is some error')
    })
  }



  const saveFormToDb=(form)=>{

    let status = 'save'
    let type = 'template'

    if(form){
      if(form.getFieldsValue()['status']){
        status = form.getFieldsValue()['status']
      }
      if(form.getFieldsValue()['type']){
        type = form.getFieldsValue()['type']
      }
    }


    setTempCreateLoading(true)
 
    const {templateRows, ques, list} = returnFormattedDemodata(demoData);

      let title = demoData.title;

      if(ques.length > 0){
        let jsonObj = {
          "json" : templateRows,
          "properties":demoData.properties
        }
        let customVariablesJSON = null;
        if(demoData.properties && demoData.properties.attachVariables == true && demoData.properties.variables){
          customVariablesJSON = {
            'variables' : demoData.properties.variables
          }
        }
   

    //=================create form
    let slugValue = slugify(demoData.title.trim(), {
      lower: true
    })
    // let slugValue = uuidv4(); 

    let variables = {
      typeValue: `${subScriber}::${type}`,
      slugValue: slugValue,
      templateName: title,
      displayName: demoData.displayName,
      templateType: 'test',
      questionRefs: ques,
      templateDesignJson: JSON.stringify(jsonObj),
      keywords: demoData.keywords && demoData.keywords.length > 0 ? demoData.keywords : null,
      customVariables: customVariablesJSON != null ? JSON.stringify(customVariablesJSON) : null
    }
    if(origObj == null){
      createForm(variables, list);
    }else{
      //========================== update form
      if(status == 'copy'){
          createForm(variables, list);
        }else{
        
          if(origObj.templateName == title){
            try{
              let variables = {
                typeValue: origObj.typeValue,
                slugValue: origObj.slugValue,
                templateName: origObj.templateName,
                displayName: demoData.displayName,
                templateType: 'test',
                questionRefs: ques,
                templateDesignJson: JSON.stringify(jsonObj),
                keywords: demoData.keywords && demoData.keywords.length > 0 ? demoData.keywords : null
              }
              updateForm(variables, demoData, list)
            }catch(err){
              console.log(err)
            }
          }else{
            try{
             let variables = {...origObj}
              variables.slugValue = slugify(demoData.title.trim(), {
                lower: true
              })
              variables.templateName = demoData.title;
              variables.displayName = demoData.displayName;
              variables.typeValue = origObj.typeValue;
              variables.templateType ='test';
              variables.questionRefs = ques;
              variables.templateDesignJson = JSON.stringify(jsonObj);
              variables.keywords = demoData.keywords && demoData.keywords.length > 0 ? demoData.keywords : null;

              delete variables['__typename'];
              delete variables['attachedQuestionRefs']
              delete variables['updatedAt']
              delete variables['updatedBy'];

              cloneFormOnTitleChange(variables, demoData, list)
              .then((data)=>{
                deleteFormTemplateMut(props,{slugValue: origObj.slugValue, typeValue: origObj.typeValue })
                .then((res)=>{
                  if(res.data.deleteFormTemplate){
                    console.log(res.data.deleteFormTemplate) 
                  }
                  setTempCreateLoading(false)
                })
                .catch((err)=>{
                  console.log(err)
                  setTempCreateLoading(false)
                 // message.error('There is some error')
                })
              })
              .catch((err)=>{
               // message.error('There is some error')
              })

            }catch(err){
              console.log(err)
              setTempCreateLoading(false)
            }
          }
        }
      }
    }else{
      setTempCreateLoading(false)
      message.warning('Please add atleast one question')
    }
  }

 

  const createForm=(variables, list)=>{
 
      createFormTemplateMut(props,variables)
      .then(async(res)=>{
       
        if(res.data.createFormTemplate && res.data.createFormTemplate != null){
          let quesres = await createFormCopyOfQuestions(list,res.data.createFormTemplate);
          if(quesres != undefined && quesres != false){
            let dd = res.data.createFormTemplate
            dd.attachedQuestionRefs = quesres;
            dd.attachedSubtemplateRef = quesres.filter((a)=>a.type == 'subtemplate') ;


            let parsedObj = JSON.parse(dd.templateDesignJson).json
       
            parsedObj.map((r)=>{
              r.templateColumns.map((t)=>{
                t.columnSections.map((c)=>{
                  c.secQuestions.map((q)=>{
                    if(q.type && q.type == 'subtemplate'){
                      let item = quesres.find((a)=>a && q && a.slugValue == q.slugValue && a.type == 'subtemplate')
                      if(item){
                        q.uId = item.uId;
                      }
                    }
                  })
                })
              })
            })
    
            dd.templateDesignJson = JSON.stringify({
              json: parsedObj,
              properties: JSON.parse(dd.templateDesignJson).properties
            })
    
          
            if(dd.templateDesignJson){
              let dd1 = getDataFromDbForm(dd)
              setdemoData(dd1)
            }
            if(designerType == 'subtemplate'){
              dispatch({
                type: ADD_SUBTEMPLATE,
                payload: dd
              })
            }else{
              dispatch({
                type: ADD_TEMPLATES,
                payload: dd
              })

            }
            updateOrigObj(dd)
            message.success('Form created successfully')
            setTempCreateLoading(false)
              if(subScriber != 'global'){
                let activityVariables={
                    typeValue: variables.typeValue,
                    slugValue: variables.slugValue,
                    uId: res.data.createFormTemplate.uId
                }
                createFormTemplateActivityMut(props,activityVariables)
                .then(({data})=>{
                    console.log(data)
                    setTempCreateLoading(false)
                })
                .catch((err)=>{
                    console.log(err)
                    setTempCreateLoading(false)
                })
            }
          }
        }

      }).catch((err)=>{
        if (err.graphQLErrors)
        err.graphQLErrors.map((res) =>{
          // console.log(res)
          if(res.errorType == 'DynamoDB:ConditionalCheckFailedException'){
         //   updateForm(variables, demoData, list);
              message.error('Form name already exists')
              setTempCreateLoading(false)
          }else{
            message.error('There is some error in saving form')
            setTempCreateLoading(false)
          }
        });    
      if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
      })
  }


    //======================== update form to db
    const cloneFormOnTitleChange=(variables, updateFormObj, list)=>{
      return new Promise((resolve,reject)=>{
        if(updateFormObj && updateFormObj != null && updateFormObj.active != undefined ){
          let variablesupdate = {...variables}
          delete variablesupdate['attachedSubtemplateRef']
            try{
              cloneFormTemplateMut(props,{ input : variablesupdate})
                .then(async({data})=>{
                
                  if(data.cloneFormTemplate && data.cloneFormTemplate != null){
                  
                    let res = await getFormTemplateBySlugValueFun(variables.slugValue)
                    if(res.data.getFormTemplateBySlugValue != null){
                      if(res.data.getFormTemplateBySlugValue.templateDesignJson){
                        let dd1 = await getDataFromDbForm(res.data.getFormTemplateBySlugValue)
                        setdemoData(dd1)
                        dispatch({
                          type: CLONE_TEMPLATE,
                          payload: { obj : res.data.getFormTemplateBySlugValue, slugValue : updateFormObj.slugValue }
                        })
                        updateOrigObj(res.data.getFormTemplateBySlugValue)
                        await updateForm(variables, updateFormObj, list)
                        resolve(true)
                      }
                    }
                  }
                  // setTempCreateLoading(false)
                }).catch((err)=>{
                  console.log(err)
                    setTempCreateLoading(false);
                     message.error("Form name already exists");
                //  message.error('There is some error in updating form')
                  reject()
                })
              }catch(err){
                console.log(err)
                reject()
                
              }
              }else{
            setTempCreateLoading(false)
          message.warning('There is some error')
        }
      })
    }

    

  //======================== update form to db
  const updateForm=(variables, updateFormObj, list)=>{
    if(updateFormObj && updateFormObj != null && updateFormObj.active != undefined ){
    //   let variablesupdate = {...variables, active:updateFormObj.active }
    let variablesupdate = {...variables, active: true }
      variablesupdate = variablesupdate
        try{
            updateFormTemplateMut(props,variablesupdate)
            .then(async({data})=>{
            
              if(data.updateFormTemplate && data.updateFormTemplate != null){
              let quesres = await createFormCopyOfQuestions(list, data.updateFormTemplate, subScriber);
  
              if(quesres != undefined && quesres != false){
                let dd = data.updateFormTemplate;
                let parsedObj = JSON.parse(dd.templateDesignJson).json

                parsedObj.map((r)=>{
                  r.templateColumns.map((t)=>{
                    t.columnSections.map((c)=>{
                      c.secQuestions.map((q)=>{
                        if(q.type && q.type == 'subtemplate'){
                          let item = quesres.find((a)=>a && q && a.slugValue == q.slugValue && a.type == 'subtemplate')
                          if(item){
                            q.uId = item.uId;
                          }
                        }
                      })
                    })
                  })
                })
        
                dd.templateDesignJson = JSON.stringify({
                  json: parsedObj,
                  properties: JSON.parse(dd.templateDesignJson).properties
                })
                updateFormTemplateMut(props, { typeValue:data.updateFormTemplate.typeValue, 
                  slugValue:data.updateFormTemplate.slugValue, 
                  templateName: data.updateFormTemplate.templateName, 
                  templateDesignJson: JSON.stringify({
                    json: parsedObj,
                    properties: JSON.parse(dd.templateDesignJson).properties
                  })
                }).then((data)=>{
                  dd.attachedQuestionRefs = quesres ;
                  dd.attachedSubtemplateRef = quesres.filter((a)=>a && a.type == 'subtemplate') ;

                  if(dd.templateDesignJson){
                      let dd1 = getDataFromDbForm(dd)
                      setdemoData(dd1)
                    }
                    if(designerType == 'subtemplate'){
                      dispatch({
                        type: ADD_SUBTEMPLATE,
                        payload: dd
                      })
                    }else{
                      dispatch({
                        type: ADD_TEMPLATES,
                        payload: dd
                      })
                    }
                    updateOrigObj(dd)
                    message.success('Form updated successfully')
                    setTempCreateLoading(false)
                })
              }
              }
            }).catch((err)=>{
              console.log(err)
                setTempCreateLoading(false)
              message.error('There is some error in updating form')
            })
          }catch(err){
            console.log(err)
          }
          }else{
        setTempCreateLoading(false)
      message.warning('There is some error')
    }
  }


  const runMutationForSubtemplate = (item, typeValue)=>{
    return new Promise((resolve, reject)=>{
      getFormTemplateByUIdQuery(props,{uId : item.uId})
      .then(({data})=>{
        let obj = data.getFormTemplateByUId;
        let variables = {
          typeValue: typeValue,
          slugValue: obj.slugValue,
          templateName: obj.templateName,
          displayName: obj.displayName,
          templateType: obj.templateType,
          subTemplate: obj.subTemplate,
          speciality: obj.speciality,
          subSpeciality: obj.subSpeciality,
          questionRefs: obj.questionRefs,
          templateRows: obj.templateRows,
          templateDesignJson: obj.templateDesignJson,
          // active: obj.active,
          keywords: obj.keywords,
          customVariables: obj.customVariables
        }
        createFormTemplateMut(props, variables)
        .then(async(res)=>{
     
          if(res.data.createFormTemplate && res.data.createFormTemplate != null){
            let quesres = await createFormCopyOfQuestions(obj.attachedQuestionRefs,res.data.createFormTemplate);

            if(quesres != undefined && quesres != false){
              item.uId = res.data.createFormTemplate.uId;
              res.data.createFormTemplate.title = res.data.createFormTemplate.templateName;
              res.data.createFormTemplate.type = 'subtemplate'
              res.data.createFormTemplate.attachedQuestionRefs = quesres
              // let data = await getFormTemplateBySlugValueQuery(props, { typeValue: typeValue, slugValue: item.slugValue })
              //   data.getFormTemplateBySlugValue.title = data.getFormTemplateBySlugValue.templateName;
              //   data.getFormTemplateBySlugValue.conditions = item.conditions;
              //   data.getFormTemplateBySlugValue.type = 'subtemplate'
              //   console.log(data.getFormTemplateBySlugValue)
              //   resolve(data.getFormTemplateBySlugValue)
              // getFormTemplateBySlugValueQuery(props, { typeValue: typeValue, slugValue: item.slugValue })
              // .then(({data})=>{
              //   data.getFormTemplateBySlugValue.title = data.getFormTemplateBySlugValue.templateName;
              //   data.getFormTemplateBySlugValue.conditions = item.conditions;
              //   data.getFormTemplateBySlugValue.type = 'subtemplate'
              //   console.log(data.getFormTemplateBySlugValue)
              //   resolve({})
              // }).catch((err)=>{
              //   reject()
              // })
              resolve(res.data.createFormTemplate)
            }else{
              reject()
            }
          }else{
            reject()
          }
        }).catch((err)=>{
 
          if (err.graphQLErrors)
          err.graphQLErrors.map((res) =>{

            if(res.errorType == 'DynamoDB:ConditionalCheckFailedException'){

              getFormTemplateBySlugValueQuery(props, { typeValue: typeValue, slugValue: item.slugValue })
              .then(({data})=>{
        
                data.getFormTemplateBySlugValue.title = data.getFormTemplateBySlugValue.templateName;
                data.getFormTemplateBySlugValue.conditions = item.conditions;
                data.getFormTemplateBySlugValue.type = 'subtemplate'

                resolve(data.getFormTemplateBySlugValue)
              }).catch((err)=>{
                reject()
              })
            }else{
              reject()
            }
          });    
        if (err.networkError) {
          reject()
          console.log(`[Network error]: ${err.networkError}`);
        }
        })
      })
      .catch((err)=>{
        console.log(err)
        reject()
      })
      
    })
  }

  //================ form copy of questions -(dependent on updateQuestionTemplateMut, createQuestionTemplateMut)
  const runMutation=(props, variables)=>{
    return new Promise((resolve,reject)=>{
      updateQuestionTemplateMut(props, variables)
      .then(({data})=>{
        resolve(data.updateQuestionTemplate)
      }).catch((err)=>{
          if (err.graphQLErrors)
            err.graphQLErrors.map((res) =>{
              if(res.errorType == 'DynamoDB:ConditionalCheckFailedException'){
                createQuestionTemplateMut(props,variables)
                .then(({data})=>{
                  resolve(data.createQuestionTemplate)
                }).catch((err)=>{
                  reject(err)
                })
              }else{
                console.log(err)
                message.error('There is some error in updating questions')
                setloading(false)
              }
            });    
        if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
      })
    })
  }


//=========== create form copy of question - (dependent on getQuestionVariablesForUpdate, runMutation, getDataFromDbForm )
  const createFormCopyOfQuestions=(list, mainObj, sId)=>{
    return new Promise((resolve,reject)=>{
      let prepend = subScriber;
      if(sId){
        prepend = sId
      }
      let arr = [];
      let uId = mainObj.uId;
      let promises=[];
    
      for(let i = 0; i < list.length; i++){
        let item = list[i];
       if(item.type == undefined){
         let variables = getQuestionVariablesForUpdate(item, uId, prepend);
         variables.typeValue = `${prepend}::${uId}::question`
         promises.push(runMutation(props,variables))
       }else{
         let typeValue = `${prepend}::${uId}::subtemplate`
        promises.push(runMutationForSubtemplate(item, typeValue))
       }
      }
 
      Promise.allSettled(promises)
      .then((data)=>{
        let arr = data.map((a)=>{
          if(a.status == 'fulfilled'){
            return a.value
          }
        })
          resolve(arr)
      
      }).catch((err)=>{
        reject(false)
        console.log(err)
      })

    })

  }



//======================= get question copy for update - deleting typename
  const getQuestionVariablesForUpdate=(item)=>{
       if (item.addNote == undefined) {
      item.addNote = false
    }  
    if (item.addNotApplicable == undefined) {
      item.addNotApplicable = false
    }
    if (item.addPainCalculation == undefined) {
      item.addPainCalculation = false
    }
    
     if (item.allowToPrint == undefined) {
      item.allowToPrint = false
    }
    
    for (let entry in item) { 
      if((entry == 'radioList' || entry == 'checkboxList') && item[entry] != null){
        item[entry].map((k)=>{
          delete k['__typename'];
        })
      }
      if((entry == 'freeText' || entry == 'number' || entry == 'date' || entry == 'file' || entry == '') && item[entry] != null){
        delete item[entry]['__typename'];
      }

      if(entry == 'refImage' && item[entry] != null){
        delete item['refImage']['__typename'];
        delete item['refImage']['imgUrl']['__typename'];
        item['refImage']['areas'].map((k)=>{
          delete k['__typename']
        })
      }
      if(entry == 'fillInBlanks' && item[entry] != null){
        delete item['fillInBlanks']['__typename']
        if(item['fillInBlanks']['blanksType'] ){
          item['fillInBlanks']['blanksType'].map((x)=>{
            delete x['__typename']
            return x;
          })
        }

    }
      if(entry == '__typename'){
        delete item['__typename']
      }
    }

    // let typeValue = `${prepend}::${uId}::question`;
    let variables = {...item }

    return variables
  }


//============================= create copy of form - (dependent on createFormCopyOfQuestions)
/**
 * 
 * @param {Object} values 
 * @param {String} sId 
 * @returns {Promise} 
 */
  const createCopyOfForm=(values, sId)=>{
    return new Promise((resolve,reject)=>{
      let variables = {
        ...values, 
        typeValue:`${sId}::template`,  
        updatedBy:null,
        updatedAt:null 
      }
   
      if(!variables.templateDesignJson || variables.templateDesignJson==null && variables.templateRows && variables.templateRows.length >0){
        try{
          let demoAssign = getDataFromDbForm(variables)
          const { templateRows } = returnFormattedDemodata(demoAssign);
          if(templateRows){
            let jsonObj = {
              "json" : templateRows
            }
            variables.templateDesignJson = JSON.stringify(jsonObj)
          }
        }catch(err){
          console.log(err)
        }
      }
      variables.templateRows = [];

      if(variables.templateDesignJson  && variables.templateDesignJson != null){
        createFormTemplateMut(props,variables)
        .then(async(res)=>{
          setloading(false)
          if(res.data.createFormTemplate && res.data.createFormTemplate != null){
              let list = values.attachedQuestionRefs;
              let quesres = await createFormCopyOfQuestions(list,res.data.createFormTemplate, sId, true)
       
              if(quesres != undefined && quesres != false){
                resolve(true)
              }
          }
        }).catch((err)=>{
          console.log(err)
          message.error('There is some error in assigning form')
          setloading(false)
          reject(true)
        if (err.networkError) console.log(`[Network error]: ${err.networkError}`);
        })

      }
    })
  }


 
  return (
      <FormContext.Provider 
        value={{
          state, 
          updateQuestionsData, 
          setdemoData,
          setloading,
          setQuesLoading,
          onChange,
          onRowTitleChange,
          onColTitleChange,
          onSecTitleChange,
          handleTemplateDisable,
          saveFormToDb,
          getQuestionVariablesForUpdate,
          createCopyOfForm,
          updateOrigObj,
          deleteQuesiton,
          getFormTemplateBySlugValueFun,
          subScriber,
           deleteFormTemplateMut
          // saveForm
        }}>
        <QuestionStoreW>
          <FormAssignStoreW>
            {props.children}
          </FormAssignStoreW>
        </QuestionStoreW>
      </FormContext.Provider>
  )
};


const FormContext = createContext(initialState);

const FormStoreW = withRouter(withApollo(FormStore))

export {
  FormReducer,
  FormStoreW,
  FormContext
}
